<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<el-dialog append-to-body class="custom-dialog filter-dialog" :title="$t('Filter')" :visible.sync="isDialogActiveLocal">
		<PerfectScrollbar ref="vueScrollBar" :settings="settings" class="scroll-area--data-list p-6">
			<div class="request-filter__item">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("StartDay") }}:</legend>
				<cbs-date-range-picker
					type="datetime"
					prefix-icon="''"
					format="dd/MM/yyyy HH:mm"
					value-format="yyyy-MM-dd HH:mm"
					:value="createdDate"
					toPlaceholder="Đến"
					fromPlaceholder="Từ"
					@change="changeCreateDate"
				/>
			</div>
			<div class="request-filter__item mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Deadline") }}:</legend>
				<cbs-date-range-picker
					type="datetime"
					prefix-icon="''"
					format="dd/MM/yyyy HH:mm"
					value-format="yyyy-MM-dd HH:mm"
					:value="deadline"
					toPlaceholder="Đến"
					fromPlaceholder="Từ"
					@change="changeDeadline"
				/>
			</div>
			<div class="mt-6" v-if="!todoFilterFlagValue || (todoFilterFlagValue && $constant.TODO_FILTER_FLAG['schedule-by-me'] !== todoFilterFlagValue)">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("TypeTodo") }}:</legend>
				<v-select
					:clearable="false"
					class="border-none w-full"
					:placeholder="`${$t('TypeTodo').toLowerCase()}`"
					:data-vv-as="$t('TypeTodo')"
					v-model="localValue.type"
					name="type"
					:options="types"
					:reduce="type => type.value"
				>
				</v-select>
			</div>

			<!-- Priority -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Priority") }}:</legend>

				<v-select
					:clearable="true"
					class="border-none w-full"
					:placeholder="`${$t('Actions.Choose')} ${$t('Priority').toLowerCase()}`"
					v-model="localValue.priority"
					name="type"
					:options="priorities"
					:reduce="type => type.value"
				>
				</v-select>
			</div>

			<!-- Status -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Status") }}:</legend>
				<v-select
					:clearable="false"
					class="border-none w-full select-multiple"
					:placeholder="`${$t('Actions.Choose')} ${$t('Status').toLowerCase()}`"
					v-model="localValue.statuses"
					name="type"
					:options="$store.state.todoListManagement.todolistCount"
					multiple
					:reduce="type => type.id"
					label="name"
				>
				</v-select>
			</div>

			<!-- Assignees -->
			<div class="mt-6" v-if="!todoFilterFlagValue || (todoFilterFlagValue && $constant.TODO_FILTER_FLAG['assigned-to-me'] !== todoFilterFlagValue)">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Employee") }}:</legend>
				<cbs-relations-humanroles
					:data-vv-as="$t('Employee')"
					:placeholder="`${$t('Actions.Choose')} ${$t('Employee').toLowerCase()}`"
					name="assignees"
					v-model="assignees"
					:type="1"
					:for="'people'"
				/>
			</div>

			<!-- Relations -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Relations") }}:</legend>

				<cbs-relations-humanroles
					:data-vv-as="$t('Relations')"
					:placeholder="`${$t('Actions.Choose')} ${$t('Relations').toLowerCase()}`"
					name="relations"
					v-model="relations"
					:type="1"
					:for="'task'"
				/>
			</div>

			<!-- Assignor   -->
			<div class="mt-6" v-if="!todoFilterFlagValue || (todoFilterFlagValue && $constant.TODO_FILTER_FLAG['created-by-me'] !== todoFilterFlagValue)">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Assignor") }}:</legend>
				<cbs-relations-humanroles
					:data-vv-as="$t('Assignor')"
					:placeholder="`${$t('Actions.Choose')} ${$t('Assignor').toLowerCase()}`"
					name="assignor"
					v-model="creator"
					:type="1"
					:for="'people'"
					:filter="'Comay\\Cmcard\\Models\\Employee'"
					:multiple="false"
				/>
			</div>
			<!-- this.$store.state.departments -->
			<!-- departments -->
			<!-- <h1>departments: {{this.$store.state.departments }} </h1> -->
			<div class="mt-6">
				<legend class="uppercase-first-letter text-solid-gray-1">{{ $t("Departments") }}:</legend>
				<v-select
					:clearable="false"
					class="border-none w-full select-multiple"
					:placeholder="`${$t('Actions.Choose')} ${$t('Departments').toLowerCase()}`"
					v-model="localValue.department_ids"
					name="type"
					:options="$store.state.departments"
					multiple
					:reduce="type => type.id"
					label="name"
				>
				</v-select>
			</div>
		</PerfectScrollbar>

		<div slot="footer" class="flex items-center justify-center">
			<vs-button type="border" @click.stop="handleResetLocalFilter" class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold">{{ $t("Actions.Reset") }}</vs-button>

			<vs-button @click.stop="onApplyFilter" class="w-full sm:w-2/5 mr-6 last:mr-0 font-bold">{{ $t("Actions.Apply") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import constant from "@/utils/constant";

import vSelect from "vue-select";

export default {
	name: "TodoFilter",
	inheritAttrs: false,
	components: { vSelect },
	props: {
		isDialogActive: {
			type: Boolean,
			required: true
		},
		todoFilterFlagValue: {
			type: Number,
			validator: prop => {
				if (prop) {
					return !!_.findKey(constant.TODO_FILTER_FLAG, flagValue => flagValue === prop);
				}
				return true;
			}
		},
		value: {
			type: Object
		}
	},
	emits: {
		onApplyFilter: {}
	},
	data() {
		return {
			isShowAdvancedFilter: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			createdDate: [],
			types: [
				{ value: null, label: this.$t("TodoFilter.All") },
				{ value: this.$constant.TODO_TYPE.NORMAL, label: this.$t("Normal") },
				{ value: this.$constant.TODO_TYPE.SCHEDULE, label: this.$t("Periodic") }
			],

			deadline: [],
			priorities: [
				{ value: 0, label: this.$t("Low") },
				{ value: 1, label: this.$t("Medium") },
				{ value: 2, label: this.$t("High") },
				{ value: 3, label: this.$t("Critical") }
			],

			statusList: [
				{ value: 0, label: this.$t("Undone") },
				{ value: 1, label: this.$t("Done") },
				{ value: 2, label: this.$t("Canceled") }
			],
			relations: null,
			assignees: null,
			creator: null,
			filters: {
				type: null,
				from_start_date: null,
				to_start_date: null,
				from_deadline: null,
				to_deadline: null,
				assignees: [],
				relations: []
			}
		};
	},
	computed: {
		isDialogActiveLocal: {
			get() {
				return this.isDialogActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeDialog");
				}
			}
		},
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		}
	},
	watch: {
		isDialogActiveLocal() {
			if (this.isDialogActiveLocal) {
				this.initFilterData();
			}
		},
		relations() {
			if (this.relations) {
				this.localValue.relations = this.relations.map(relation => {
					return { id: relation.id, type: relation.type };
				});
			} else {
				this.localValue.relations = [];
			}
		},
		assignees() {
			if (this.assignees) {
				this.localValue.assignees = this.assignees.map(assignee => {
					return { id: assignee.id, type: assignee.type };
				});
			} else {
				this.localValue.assignees = [];
			}
		},
		creator() {
			this.localValue.creator_employee_id = this.creator ? this.creator.id : null;
		}
	},
	methods: {
		onApplyFilter() {
			this.$emit("onApplyFilter", this.localValue);
		},
		initFilterData() {},
		handleResetLocalFilter() {
			this.createdDate = [];
			this.deadline = [];
			this.relations = null;
			this.assignees = null;
			this.creator = null;
			this.localValue = {
				type: null,
				from_start_date: null,
				to_start_date: null,
				from_deadline: null,
				to_deadline: null,
				assignees: [],
				relations: []
			};
		},
		changeCreateDate(data) {
			this.createdDate = data;
			this.localValue.from_start_date = this.createdDate[0] ? moment(this.createdDate[0]).toISOString() : null;
			this.localValue.to_start_date = this.createdDate[1] ? moment(this.createdDate[1]).toISOString() : null;
		},
		changeDeadline(data) {
			this.deadline = data;
			this.localValue.from_deadline = this.deadline[0] ? moment(this.deadline[0]).toISOString() : null;
			this.localValue.to_deadline = this.deadline[1] ? moment(this.deadline[1]).toISOString() : null;
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-dialog.filter-dialog {
	::v-deep .el-dialog {
		margin-right: 0 !important;
	}
}

.request-filter {
	.request-filter__item {
		&:not(:last-child) {
			margin-right: 15px;
		}

		::v-deep .vs__dropdown-menu {
			top: initial;
		}
	}
}

.dialog-fade-enter-active {
	animation: dialog-fade-in 0.2s ease-in-out;
}

.dialog-fade-leave-active {
	animation: dialog-fade-out 0.5s ease-in-out;
}

@keyframes dialog-fade-in {
	0% {
		opacity: 0;
		transform: translateX(100%);
	}
	100% {
		opacity: 1;
		transform: translateX(0);
	}
}

@keyframes dialog-fade-out {
	0% {
		opacity: 1;
		transform: translateX(0);
	}
	100% {
		opacity: 0;
		transform: translateX(100%);
	}
}
</style>
